<template>
<div class="trending-container">
    <div class="trending-title-container">
        <span>TRENDING</span>
    </div>
    <div class="sliders-container occasion">
        <VueSlickCarousel :infinite="true" :arrows="true" :slidesToShow="1" :slidesToScroll="1">
            <template #prevArrow="arrowOption">
                <div>
                  <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_left.svg?v=1657408648">
                </div>
              </template>
            <div class="trending-slide">
                <div class="content-container feb">
                    <p class="title">The Q4 Corporate Gifting Trend Report</p>
                    <p class="subtitle">Holiday gifting is almost here! Download the report for the latest gifting insights to impress clients & reward your team.</p>
                    <a href="https://happyboxstore.com/index#q4trendReport2024" class="happybox-button green border">Download the Report</a>
                </div>
                <div class="image-container">
                    <img class="lazyload" src="https://cdn.shopify.com/s/files/1/1363/8433/files/q4trendreport.png?v=1727725250"/>
                </div>
                <p class="title mobile">The Q4 Corporate Gifting Trend Report</p>
            </div>
            <div class="trending-slide">
                <div class="content-container feb">
                    <p class="title">Welcome <br/> Them Back <br/> to the Office</p>
                    <p class="subtitle">Maybe it’s their first time back to the office in quite a while. Extend a warm welcome by leaving a thoughtful care package on their desk, setting the tone for a smooth transition back.</p>
                    <a href="/pages/ready-to-ship" class="happybox-button green border">Browse the Collection</a>
                </div>
                <div class="image-container">
                    <img class="lazyload" src="https://cdn.shopify.com/s/files/1/1363/8433/files/deskdrop.png?v=1711382937"/>
                </div>
                <p class="title mobile">Welcome <br/> Them Back <br/> to the Office</p>
            </div>
            <div class="trending-slide">
                <div class="content-container">
                    <p class="title">Our Event <br/> Gifting Service</p>
                    <p class="subtitle">Whether it's for a corporate conference or an intimate
                    celebration, we'll help you create a thoughtfully curated
                    gift that will be <br class="desktop"/> cherished by your guests.</p>
                    <a target="_blank" href="https://meetings.hubspot.com/corporate-gifting" class="happybox-button green border">Book a Call</a>
                </div>
                <div class="image-container">
                    <img loading="lazy" src="https://cdn.shopify.com/s/files/1/1363/8433/files/event.png?v=1709316145"/>
                </div>
                <p class="title mobile">Our Event <br/> Gifting Service</p>
            </div>
            <div class="trending-slide">
                <div class="content-container">
                    <p class="title">Care Packages for the Whole Team</p>
                    <p class="subtitle">Show your team some love and build a custom gift right now! Shipping made easy.</p>
                    <a id="builder" href='/products/build-a-box' class="happybox-button green border">Start building</a>
                </div>
                <div class="image-container">
                    <img loading="lazy" src="https://cdn.shopify.com/s/files/1/1363/8433/files/raiseaglass2.jpg?v=1704228993"/>
                </div>
                <p class="title mobile">Care Packages for <br/> the Whole Team</p>
            </div>
            <div class="trending-slide">
                <div class="content-container">
                    <p class="title">Revitalize Your Workplace</p>
                    <p class="subtitle">Stress is so last season. Embrace corporate wellness for a healthier, happier, and more productive team in 2024.</p>
                    <a href="/collections/wellness" class="happybox-button white border">Shop wellness gifts</a>
                </div>
                <div class="image-container">
                    <img class="lazyload" src="https://cdn.shopify.com/s/files/1/1363/8433/products/3bc81609fd6822f4f44bf98014bc2ffd224d78f65c7a9d28efad777d8aa1a31c.webp?v=1674963892"/>
                </div>
                <p class="title mobile">Revitalize Your Workplace</p>
            </div>
            <template #nextArrow="arrowOption">
                <div>
                  <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_right.svg?v=1657408648">
                </div>
              </template>
        </VueSlickCarousel>
    </div>
</div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  components: {
    VueSlickCarousel,
  },
  data(){
    return {}
  },
  computed:{
  },
  methods:{
  }
}
</script>

<style>

.sliders-container.occasion .slick-prev::before, .sliders-container.occasion .slick-next::before{
    display: none;
}

.sliders-container.occasion .slick-next, .sliders-container.occasion .slick-prev{
    display: flex;
    width: 5%;
    height: auto;
}

.sliders-container.occasion .slick-next{
    right: 5%;
}

.sliders-container.occasion .slick-prev{
    left: 5%;
}

.sliders-container.occasion .slick-arrow img{
	width: 100%;
}

@media screen and (max-width: 767px) {
	.sliders-container.occasion .slick-next, .sliders-container.occasion .slick-prev{
		width: 10%;
	}

	.sliders-container.occasion .slick-next{
		right: -5%;
	}

	.sliders-container.occasion .slick-prev{
		left: -5%;
	}
}
</style>
<style scoped>

    .trending-container{
		width: 100%;
		padding: 2% 0%;
		margin-bottom: 5%;
	}

	.trending-container .sliders-container{
		width: 100%;
		box-shadow: 0px 0px 10px 2px rgba(0,0,0,0.1);
		background-color: white;
		border-radius: 8px;
	}

	.trending-slide{
		width: 100%;
    	display: flex !important;
		padding: 2% 10%;
		position: relative;
	}

	.trending-slide .calendar{
		position: absolute;
		width: 4%;
		left: 49.5%;
		top: 5%;
	}

	.trending-slide .content-container{
		width: 50%;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		padding-left: 4%;
	}

	.trending-slide .content-container.feb{
		padding-left: 4%;
	}

	.trending-slide .content-container .title{
		font-size: 3vw;
		line-height: 1;
		font-family: "ff-more-web-pro-condensed", "Karla", sans-serif;
		font-weight: 300;
	}

	.trending-slide .content-container .subtitle{
		font-size: 1.15vw;
		line-height: 1.2;
	}

	.trending-slide .content-container a{
		width: 90%;
	}

	.trending-slide .image-container{
		width: 50%;
		padding: 0 5%;
	}

	.trending-slide .image-container img{
		width: 100%;
		border-radius: 50%;
		aspect-ratio: 1;
	}

	.trending-title-container{
		text-align: center;
    	margin-bottom: -1.5%;
	}

	.trending-title-container span{
		background-color: #ffd9c5;
		padding: 1% 2%;
		font-weight: bold;
		font-size: 1.15vw;
		border-radius: 4px;
	}

    @media screen and (max-width: 767px) {
        .trending-container{
			padding: 5% 5% 1%;
		}

		.trending-title-container{
			margin-bottom: -3.5%;
		}

		.trending-title-container span{
			font-size: 3.5vw;
			padding: 2% 4%;
		}

		.trending-container .sliders-container{
			padding: 0%;
		}

		.trending-slide{
			flex-direction: column-reverse;
			align-items: center;
			padding: 5%;
		}
		

		.trending-slide .image-container{
			width: 100%;
		}

		.trending-slide .content-container{
			padding: unset;
			width: 100%;
			text-align: center;
			align-items: center;
		}

		.trending-slide .content-container .title{
			display: none;
		}

		.trending-slide .content-container .subtitle{
			font-size: 3.5vw;
			margin-bottom: 2rem;
		}
  
		.trending-slide .title.mobile{
			font-size: 7vw;
			margin: unset;
			text-align: center;
			line-height: 1;
			font-family: "ff-more-web-pro-condensed", "Karla", sans-serif;
			font-weight: 300;
			margin-top: 1rem;
		}

		.trending-slide .calendar{
			position: initial;
			width: 15%;
			margin-bottom: 5%;
		}

		.trending-slide .content-container a{
			padding: 2%;
			width: 100%;
		}

        .trending-container .swiper{
			padding: 0 !important;
		}

		.trending-container .swiper-slide{
			padding: 10%;
		}

        .trending-slide .image-container img{
			margin: 10% 0%;
		}
    }
</style>